import React from 'react';

const LunchboxHome = ({ stats, onNavigateToCalendar }) => {
  const lunchboxTypes = [
    {
      type: 'A',
      name: '家常風味',
      color: 'orange',
      icon: '🍳',
      description: '傳統中式家常菜，適合喜歡熟悉口味的學生'
    },
    {
      type: 'B',
      name: '特式風味',
      color: 'blue',
      icon: '🍽️',
      description: '特色菜式和國際風味，提供多元化選擇'
    },
    {
      type: 'C',
      name: '至營推介',
      color: 'red',
      icon: '❤️',
      description: '營養均衡的推薦餐點，注重健康飲食'
    },
    {
      type: 'D',
      name: '健康素食',
      color: 'green',
      icon: '🌱',
      description: '素食選項，適合素食者或想要清淡飲食的學生'
    }
  ];

  return (
    <div className="lunchbox-home">
      <div className="home-header">
        <h2>飯盒系統概覽</h2>
        <p>管理每日餐單、記錄學生飯盒訂購情況</p>
      </div>

      {/* Statistics Cards */}
      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-icon">👨‍🎓</div>
          <div className="stat-content">
            <h3>總學生數</h3>
            <div className="stat-number">{stats.totalStudents}</div>
            <p>全校學生</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">🏫</div>
          <div className="stat-content">
            <h3>班級數量</h3>
            <div className="stat-number">{stats.totalClasses}</div>
            <p>完整配置</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">🍱</div>
          <div className="stat-content">
            <h3>飯盒類型</h3>
            <div className="stat-number">{stats.lunchboxTypes.length}</div>
            <p>種選擇</p>
          </div>
        </div>
      </div>

      {/* Lunchbox Types */}
      <div className="lunchbox-types-section">
        <h3>飯盒類型介紹</h3>
        <div className="lunchbox-types-grid">
          {lunchboxTypes.map((lunchbox) => (
            <div key={lunchbox.type} className={`lunchbox-type-card ${lunchbox.color}`}>
              <div className="lunchbox-type-header">
                <span className="lunchbox-icon">{lunchbox.icon}</span>
                <div className="lunchbox-type-info">
                  <h4>類型 {lunchbox.type}</h4>
                  <h5>{lunchbox.name}</h5>
                </div>
              </div>
              <p className="lunchbox-description">{lunchbox.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions-section">
        <h3>快速操作</h3>
        <div className="quick-actions-grid">
          <button 
            className="action-btn primary"
            onClick={onNavigateToCalendar}
          >
            <span className="action-icon">📅</span>
            <div className="action-content">
              <h4>查看月曆</h4>
              <p>查看每日餐單和訂購記錄</p>
            </div>
          </button>
          
          <button className="action-btn secondary">
            <span className="action-icon">📊</span>
            <div className="action-content">
              <h4>統計報告</h4>
              <p>查看飯盒訂購統計</p>
            </div>
          </button>
          
          <button className="action-btn secondary">
            <span className="action-icon">⚙️</span>
            <div className="action-content">
              <h4>系統設定</h4>
              <p>管理餐單和系統配置</p>
            </div>
          </button>
        </div>
      </div>

      {/* Class List */}
      <div className="class-list-section">
        <h3>班級列表</h3>
        <div className="class-list-grid">
          {stats.classList.map((classId) => (
            <div key={classId} className="class-item">
              <span className="class-name">{classId}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LunchboxHome;
